import { useFormatter } from '@eneco/i18n';
import { type Fields } from '@sitecore/types/OfferStep';

import { FlowConsumerContextEnergy } from '../../context';

interface UseConsumptionOverviewParams {
  flowContext: FlowConsumerContextEnergy;
  textualData?: Fields;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sendToFlowMachine: (event: any) => void;
}

export function useConsumptionOverview({ flowContext, textualData, sendToFlowMachine }: UseConsumptionOverviewParams) {
  const { format, address } = useFormatter();

  const {
    street,
    houseNumber,
    houseNumberSuffix,
    city,
    hasDoubleMeter,
    hasSolarPanels,
    usageElectricityHigh,
    usageElectricityLow,
    usageGas,
    usageWarmth,
    usageWater,
    solarPanelsOutput,
    isUsageDetailsEditProhibited,
  } = flowContext;

  const consumptionTextualData = {
    description: format(textualData?.footer?.footerDescription?.value ?? '', {
      address: address.medium({ street, houseNumber, houseNumberSuffix, city }),
    }),
    redeliveryLabel: textualData?.footer?.redeliveryLabel?.value,
    electricityLabel: textualData?.footer?.electricityLabel?.value,
    electricityHighLabel: textualData?.footer?.electricityHighLabel?.value,
    electricityLowLabel: textualData?.footer?.electricityLowLabel?.value,
    gasLabel: textualData?.footer?.gasLabel?.value,
    warmthLabel: textualData?.footer?.warmthLabel?.value,
    waterLabel: textualData?.footer?.waterLabel?.value,
  };

  const consumptionData = {
    hasDoubleMeter,
    hasSolarPanels,
    usageElectricityHigh,
    usageElectricityLow,
    usageGas,
    usageWarmth,
    usageWater,
    solarPanelsOutput,
  };

  let consumptionEditButton;

  if (!isUsageDetailsEditProhibited) {
    consumptionEditButton = {
      label: textualData?.footer?.modifyTriggerText?.value ?? '',
      onClick: () => sendToFlowMachine({ type: 'GOTO', stepName: 'STEP_USAGE' }),
    };
  }

  return {
    consumptionTextualData,
    consumptionData,
    consumptionEditButton,
  };
}
